// NG 2
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule } from "@angular/router";
import { DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { Http, Headers, BaseRequestOptions } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TextMaskModule } from 'angular2-text-mask';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

// APP
import { AppComponent } from './app.component';
import { AppRoutingModule, routingComponents } from './app.routing.module';
import { EntitydetailComponent } from './components/entities/entitydetail.component';
import { SiteEntityDetailComponent } from './components/entities/siteentitydetail.component';
import { ErrorsComponent } from './components/errors/errors.component';
import { TimeoutComponent } from "./components/common/timeout.component";

// Pipes
import { PhonePipe } from './pipes/phone.pipe';
import { TinPipe } from './pipes/tin.pipe';
import { ZipPipe } from './pipes/zip.pipe';
import { EntitytypePipe } from './pipes/entitytype.pipe';
import { BldgtrackingtypePipe } from './pipes/bldgtrackingtype.pipe';
import { OrderByPipe } from './pipes/orderby.pipe';
import { OrderByUploadPipe } from './pipes/orderbyupload.pipe';

import { AutoCompleteComponent } from './components/test/auto-complete.component';
import { AutoCompleteSearchService } from './components/test/auto-complete.service';
import { LocalStorageService } from './components/test/storage.service';
import { GlobalRef, BrowserGlobalRef } from './components/test/windowRef.service';

// Services
import { AppConfig } from './app.config';
import { ProgressService } from './services/progress.service';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthenticationService } from './services/authentication.service';
import { SharedService } from './services/shared.service';
import { LookupService } from './services/lookup.service';
import { FilesService } from './services/files.service';
import { HelperService } from '../app/services/helper.service';
import { FoucsChangeService } from '../app/services/focuschange.service';
import { FocusDirective } from './directives/autofocuselement.directive';
import { CacheRemovalInterceptor } from './interceptors/cacheremoval.interceptor';
import { httpFactory } from './interceptors/http.factory';
import { XHRBackend, RequestOptions } from "@angular/http";
import { AppModeGuard } from './guards/appmode.guard';
import { IdleExpiry, NgIdleModule, Idle, SimpleExpiry } from '@ng-idle/core';
import { NumbersOnlyDirective } from './directives/numbersonly.directive';
import { ApplicationUploadComponent } from './components/entities/applicationupload.component';
import { ChecklistComponent } from './components/entities/checklist.component';

export function ConfigLoader(appConfig: AppConfig) {
    return () => appConfig.load();
}

@NgModule({  

  bootstrap: [AppComponent],
  declarations: [AppComponent, ApplicationUploadComponent, ChecklistComponent, routingComponents, TinPipe, PhonePipe, ZipPipe,
        EntitytypePipe, BldgtrackingtypePipe, OrderByPipe, OrderByUploadPipe, EntitydetailComponent, SiteEntityDetailComponent, TimeoutComponent,
      AutoCompleteComponent, ErrorsComponent, FocusDirective, NumbersOnlyDirective 
  ],
    imports: [
        FormsModule,
        NgIdleModule,
        ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpModule,
        TextMaskModule,        
        AppRoutingModule,
        AngularMultiSelectModule,
        PdfJsViewerModule	   
  ],
  exports: [
      AutoCompleteComponent
  ],
  providers: [Title, AuthGuardService, AuthenticationService, SharedService, HelperService, FoucsChangeService,
      LookupService, ProgressService,
      FilesService, AutoCompleteSearchService, LocalStorageService,
      AppConfig, DatePipe, AppModeGuard,
      {
          provide: APP_INITIALIZER,
          useFactory: ConfigLoader,
          deps: [AppConfig],
          multi: true
      },
      //{ provide: HTTP_INTERCEPTORS, useClass: CacheRemovalInterceptor, multi: true },
      SimpleExpiry, {provide: IdleExpiry, useExisting: SimpleExpiry}, Idle,
      { provide: Http, useFactory: httpFactory, deps: [XHRBackend, RequestOptions] },
      { provide: GlobalRef, useClass: BrowserGlobalRef }
  ]
})
export class AppModule {
}
